import { trackById } from 'src/app/shared/utils/track-by.util';
import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Task } from 'src/app/models/task.model';

@Component({
  standalone: false,
  selector: 'app-task-report',
  templateUrl: './task-report.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./task-report.component.scss']
})
export class TaskReportComponent implements OnInit {
  @Input() segTasks: Task[];

  constructor() { }

  ngOnInit(): void {
  }

  public trackById = trackById;
}
